import axios from "axios";

export const apiUrlDespesas = `${process.env.TRANSPARENCY_API_URL}/despesas`;

const axiosClient = axios.create({
  baseURL: `${apiUrlDespesas}`,
  timeout: 0,
  headers: {},
});

export async function getDespesasDetalhamento(
  exercicio: string,
  empenho_codigo: string,
  unidade_gestora_codigo: string
): Promise<any> {
  try {
    const { data } = await axiosClient.get(
      `/${exercicio}/${empenho_codigo}/${unidade_gestora_codigo}/detalhamento/`,
      {
        headers: {
          "Accept-Encoding": "gzip, deflate, br",
          Accept: "application/json, text/plain, */*",
        },
      }
    );
    return Promise.resolve(data);
  } catch (e) {
    return Promise.reject(e);
  }
}

export async function getDespesasHistorico(
  exercicio: string,
  empenho_codigo: string,
  unidade_gestora_codigo: string
): Promise<any> {
  try {
    const { data } = await axiosClient.get(
      `/${exercicio}/${empenho_codigo}/${unidade_gestora_codigo}/financial_history/`,
      {
        headers: {
          "Accept-Encoding": "gzip, deflate, br",
          Accept: "application/json, text/plain, */*",
        },
      }
    );
    return Promise.resolve(data);
  } catch (e) {
    return Promise.reject(e);
  }
}

export async function getDespesasListagem(
  exercicio: string,
  referencia_ate: string,
  referencia_de: string
): Promise<any> {
  try {
    const { data } = await axiosClient.get(
      `/${exercicio}/${referencia_de}/${referencia_ate}/`,
      {
        headers: {
          "Accept-Encoding": "gzip, deflate, br",
          Accept: "application/json, text/plain, */*",
        },
      }
    );
    return Promise.resolve(data);
  } catch (e) {
    return Promise.reject(e);
  }
}

export async function getDespesasDownload(
  exercicio: string,
  referencia_ate: string,
  referencia_de: string
): Promise<any> {
  try {
    const response = await axiosClient.get(
      `/${exercicio}/${referencia_de}/${referencia_ate}/download/`,
      {
        responseType: "blob",
        headers: {
          "Accept-Encoding": "gzip, deflate, br",
        },
      }
    );
    return Promise.resolve(response);
  } catch (e) {
    return Promise.reject(e);
  }
}

export async function getDespesasExercicios(): Promise<any> {
  try {
    const { data } = await axiosClient.get(`/exercicios/`, {
      headers: {
        "Accept-Encoding": "gzip, deflate, br",
        Accept: "application/json, text/plain, */*",
      },
    });
    console.log(data);
    return Promise.resolve(data);
  } catch (e) {
    return Promise.reject(e);
  }
}

export async function getDespesasOrgaos(
  exercicio: string,
  referencia_ate: string,
  referencia_de: string
): Promise<any> {
  try {
    const { data } = await axiosClient.get(
      `/orgaos/${exercicio}/${referencia_de}/${referencia_ate}/`,
      {
        headers: {
          "Accept-Encoding": "gzip, deflate, br",
          Accept: "application/json, text/plain, */*",
        },
      }
    );
    return Promise.resolve(data);
  } catch (e) {
    return Promise.reject(e);
  }
}

export async function getDespesasReferencias(exercicio: string): Promise<any> {
  try {
    const { data } = await axiosClient.get(`/referencias/${exercicio}/`, {
      headers: {
        "Accept-Encoding": "gzip, deflate, br",
        Accept: "application/json, text/plain, */*",
      },
    });
    return Promise.resolve(data);
  } catch (e) {
    return Promise.reject(e);
  }
}

export async function getDespesasLastUpdate(): Promise<any> {
  try {
    const { data } = await axiosClient.get(`/updated_at/`, {
      headers: {
        "Accept-Encoding": "gzip, deflate, br",
        Accept: "application/json, text/plain, */*",
      },
    });
    return Promise.resolve(data);
  } catch (e) {
    return Promise.reject(e);
  }
}
